export const carouselDataCard = [
    {
        icon: 'economic-chart-icon',
        url: '/osh-context/economic-sector-profile',
        titleLiteral: '22003',
        bodyLiteral: '22028',
    },
    {
        icon: 'national-icon',
        url: '/osh-steering/national-strategies/',
        titleLiteral: '22007',
        bodyLiteral: '22038',
    },
    {
        icon: 'work-accidents-icon',
        url: 'accidents-diseases-well-being/work-accidents/non-fatal-work-accidents',
        titleLiteral: '22010',
        bodyLiteral: '22050',
    },
    {
        icon: 'statistics-icon',
        url: '/osh-infrastructure/osh-statistics',
        titleLiteral: '22018',
        bodyLiteral: '22065',
    },
    {
        icon: 'working-conditons-icon',
        url: '/working-conditions-preventions/working-conditions',
        titleLiteral: '22013',
        bodyLiteral: '22054',
    },
    {
        icon: 'people-group-icon',
        url: '/osh-context/workforce-profile/median-age/ageing-workers',
        titleLiteral: '22004',
        bodyLiteral: '22030',
    },
]